"use client";
import Image from "next/image";
import { useMarquee } from "@/hooks/useMarquee";

const clients = [
    { src: "/images/clients/Assetpass.png", alt: "Assetpass" },
    { src: "/images/clients/Cabotto.png", alt: "Cabotto" },
    { src: "/images/clients/Esiance.png", alt: "Esiance" },
    { src: "/images/clients/Espeakers.png", alt: "Espeakers" },
    { src: "/images/clients/G2n0.png", alt: "G2n0" },
    { src: "/images/clients/Integrtypro.png", alt: "Integrtypro" },
    { src: "/images/clients/Kabinata.png", alt: "Kabinata" },
    { src: "/images/clients/Orange_climate.png", alt: "Orange_climate" },
    { src: "/images/clients/Rovero.png", alt: "Rovero" },
    { src: "/images/clients/Sensai_network_cognition.png", alt: "Sensai_network_cognition" },
    { src: "/images/clients/Zynerd.png", alt: "Zynerd" },
];

const ClientArea = () => {
    const { containerRef, trackRef } = useMarquee({
        speed: 1,
        direction: 'right',
        pauseOnHover: true
    });

    return (
        <div className="desilo-lients-area">
            <div className="">
                <div className="">
                    <div>
                        <div className="container custom-container">
                            <div className="row g-4">
                                <div className="col-12">
                                    <p>
                                        Trusted by leading brands
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div ref={containerRef} className="marquee-container">
                            <div ref={trackRef} className="marquee-track">
                                {/* First set of logos */}
                                {clients.map((item, i) => (
                                    <div key={`first-${i}`} className="marquee-item">
                                        <div className="client-box">
                                            <Image
                                                height={0}
                                                width={0}
                                                src={item.src}
                                                alt={item.alt}
                                                className="client-logo w-100 h-100"
                                                sizes="100px"
                                                loading="lazy"
                                            />
                                        </div>
                                    </div>
                                ))}
                                {/* Second set for seamless loop */}
                                {clients.map((item, i) => (
                                    <div key={`second-${i}`} className="marquee-item">
                                        <div className="client-box">
                                            <Image
                                                height={0}
                                                width={0}
                                                src={item.src}
                                                alt={item.alt}
                                                className="client-logo w-100 h-100"
                                                sizes="100px"
                                                loading="lazy"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientArea;
